module.exports = __webpack_public_path__ + "static/img/github-logo.ff48e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/github-logo.jpg
// module id = A2gH
// module chunks = 1